import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge only knows Tailwind's default `fontSize` scale (xs, sm,
 * base, lg...). Our editorial type scale (tailwind.config.js) adds its own
 * keys — micro, small, body, subhead, page-title, display-l, display-xl,
 * metric — which twMerge doesn't recognize as font-size utilities. It falls
 * back to classifying `text-micro` etc. as a text-COLOR utility (its generic
 * catch-all group), so `text-micro` and `text-paper` land in the same
 * conflict group and only the one appearing later in the string survives.
 * That silently deleted `text-paper` off every `<Button size="sm">` using the
 * default/destructive/secondary variant — the button text became invisible
 * against its own background. Registering these keys under `font-size`
 * fixes it at the root instead of patching every call site.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{
        text: ['micro', 'small', 'body', 'subhead', 'page-title', 'display-l', 'display-xl', 'metric'],
      }],
    },
  },
});

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
